import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css"; // Swiper 스타일을 가져옵니다.
import "swiper/css/bundle";
import "swiper/css";

import MyValidationEng from "../components_library/MyValidationEng";

import ic_propose from "@asset/icon/ic_propose.png";
import logoset_w from "@asset/logo/logo_MindsAI_white.png";
import logoset from "@asset/logo/logo_MindsAI_color.png";

import "./ProposeEng.css";
import TopButton from "../components_library/TopButton";

export default function ProposeEng() {
  return (
    <div className="proposeEng">
      <TopButton />
      <div className="p_main_bg">
        <div class="inner">
          <div class="p_title">
            <img id="p_logo" src={ic_propose} alt="ic_propose" />
            <p id="p_title_01">MINDSAI Business</p>
            <h1 id="p_title_02">Partnership·Proposal</h1>
          </div>

          <div class="p_subtitle">
            <h1 id="p_subtitle_01">Inquiry for Partnership·Proposal</h1>
            <p id="p_subtitle_02">
              {" "}
              You can inquire about the partnership proposal of Minds. NAVI,
              CHEEU. Forest and CHEEU. Counsel. If you fill out the form below
              and register, we will contact you after checking.
              <br />
              Thank you.
            </p>
          </div>
        </div>
      </div>

      <div className="p_form">
        <div className="inner">
          <MyValidationEng />
        </div>
      </div>
    </div>
  );
}
